export default class Web {
  constructor() {
    this.es = new Object();
    this.en = new Object();
    this.fr = new Object();
  }
}
